import React from 'react';
import { VERSION } from 'version';
import { Btn } from 'shared/ui/Btn';
import logo from 'logo.svg';

type Props = { error: string | null; onSignIn: () => void };

/**
 * Tokenised replacement for the unauthenticated branch of App.js's
 * AuthWrapper. Same copy, same single SAML action. The `<h1>` is a real fix,
 * not a like-for-like port: the classic markup rendered it `text-gray-800` on
 * a `bg-black` card (App.js:274-275), which was effectively invisible; here
 * it inherits `text-ink` and actually shows.
 */
export function LoginCard({ error, onSignIn }: Props) {
  const title = process.env.REACT_APP_TITLE || 'V5000 System Configurator';
  return (
    <div className="flex min-h-screen items-center justify-center bg-ground p-6 font-body text-ink">
      <div className="w-full max-w-md overflow-hidden rounded-[var(--radius-2)] border border-brand/40 bg-surface shadow-2xl">
        <div className="px-6 py-5 text-center">
          <img src={logo} alt="VDURA Logo" className="mx-auto mb-2 w-48" />
          <h1 className="font-display text-xl font-bold">
            {title}
            <span className="ml-2 font-code text-xs text-ink-muted">v{VERSION}</span>
          </h1>
        </div>
        <div className="px-6 pb-6">
          <p className="mb-6 text-center text-sm text-ink-muted">
            Please sign in to access the storage configurator and quote generator
          </p>
          {error && (
            <div
              role="alert"
              className="mb-4 rounded-[var(--radius-2)] border border-danger/50 bg-danger/10 px-3 py-2 text-sm text-danger"
            >
              {error}
            </div>
          )}
          <Btn variant="contained" size="lg" className="w-full" onClick={onSignIn}>
            Sign In with SAML
          </Btn>
          <p className="mt-4 text-center text-xs text-ink-muted">
            You'll be redirected to the secure login page with your company's identity provider
          </p>
        </div>
        <div className="border-t border-hairline/15 bg-surface-raised px-6 py-3">
          <p className="text-center text-tiny text-ink-muted">
            VDURA Confidential and Proprietary, NDA required. 2025
          </p>
        </div>
      </div>
    </div>
  );
}
